import { InMemoryCache } from '@apollo/client';

export function configureCache() {
    return new InMemoryCache({
        typePolicies: {
            Customer: {
                keyFields: ['cid'],
            },
            Query: {
                fields: {
                    // ultimasSuscripcionesConnection: {
                    //     // Don't cache separate results based on
                    //     // any of this field's arguments.
                    //     keyArgs: ['filters', 'sparkline'], // Concatenate the incoming list items with
                    //     // the existing list items.
                    //     merge: mergeCursorStyle,
                    // },
                    bloqueosConnection: {
                        // Don't cache separate results based on
                        // any of this field's arguments.
                        keyArgs: ['incluirViejos', 'filtros'], // Concatenate the incoming list items with
                        // the existing list items.
                        merge: mergeCursorStyle,
                    },
                    eventsConnection: {
                        // Don't cache separate results based on
                        // any of this field's arguments.
                        keyArgs: ['filters'], // Concatenate the incoming list items with
                        // the existing list items.
                        merge: mergeCursorStyle,
                    },
                    trialsActivosConnection: {
                        // Don't cache separate results based on
                        // any of this field's arguments.
                        keyArgs: ['filters'], // Concatenate the incoming list items with
                        // the existing list items.
                        merge: mergeCursorStyle,
                    },
                    contratacionesConnection: {
                        // Don't cache separate results based on
                        // any of this field's arguments.
                        keyArgs: ['filters'], // Concatenate the incoming list items with
                        // the existing list items.
                        merge: mergeCursorStyle,
                    },
                    ipnConnection: {
                        // Don't cache separate results based on
                        // any of this field's arguments.
                        keyArgs: ['filters'], // Concatenate the incoming list items with
                        // the existing list items.
                        merge: mergeCursorStyle,
                    },
                    zenriseWebhooksConnection: {
                        // Don't cache separate results based on
                        // any of this field's arguments.
                        keyArgs: ['filters'], // Concatenate the incoming list items with
                        // the existing list items.
                        merge: mergeCursorStyle,
                    },
                    invoicesZenRiseConnection: {
                        // Don't cache separate results based on
                        // any of this field's arguments.
                        keyArgs: ['filters'], // Concatenate the incoming list items with
                        // the existing list items.
                        merge: mergeCursorStyle,
                    },
                    procesosDiariosConnection: {
                        // Don't cache separate results based on
                        // any of this field's arguments.
                        keyArgs: ['filters'], // Concatenate the incoming list items with
                        // the existing list items.
                        merge: mergeCursorStyle,
                    },
                },
            },
        },
    });
}

interface CursorStyle<Node> {
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges: Node[];
}

/**
 * Mergea los resultados al estilo Cursor, siempre agregando al final.
 */
function mergeCursorStyle<Node>(
    existing: CursorStyle<Node> | undefined,
    incoming: CursorStyle<Node>
): CursorStyle<Node> {
    return {
        pageInfo: incoming.pageInfo,
        edges: [...(existing?.edges ?? []), ...incoming.edges],
    };
}
